export default __webpack_public_path__ + "static/media/Le trajet le plus court  .f21c6d9c.jpeg";